import { render, staticRenderFns } from "./TradesmanThumbList.vue?vue&type=template&id=481a8bf4&scoped=true&"
import script from "./TradesmanThumbList.vue?vue&type=script&lang=js&"
export * from "./TradesmanThumbList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481a8bf4",
  null
  
)

export default component.exports